/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export default [
    [
        ['Mitternacht', 'morgens', 'vormittags', 'mittags', 'nachmittags', 'abends', 'nachts'],
        ,
    ],
    [
        ['Mitternacht', 'Morgen', 'Vormittag', 'Mittag', 'Nachmittag', 'Abend', 'Nacht'],
        ,
    ],
    [
        '00:00', ['05:00', '10:00'], ['10:00', '12:00'], ['12:00', '13:00'], ['13:00', '18:00'],
        ['18:00', '24:00'], ['00:00', '05:00']
    ]
];
//# sourceMappingURL=de.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/common/locales/extra/de.js
// module id = null
// module chunks = 